import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Meta } from '@df/core/meta/meta';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { ShellComponent } from '@df/ui/common/shell/shell.component';
import { CountdownComponent } from '@df/ui/display/countdown.component';
import { YoutubePlayerComponent } from '@df/ui/display/media/youtube-player.component';
import { NToggle, ToggleService } from '@df/ui/toggle/toggle.service';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { LocalVimeoPlayerComponent } from '../../../ui/display/media/vimeo-player.component';
import { CMS_COMPONENT_HERO_IMAGE_CONFIG } from './cms-component-hero-image.config';
import { NCmsComponentHeroImage } from './cms-component-hero-image.interface';

let uid = 0;

export const cmsHeroImageUid = () => {
    return uid++;
};

@Component({
    selector: 'cms-component-hero-image',
    templateUrl: './cms-component-hero-image.component.html',
    styleUrl: './cms-component-hero-image.component.scss',
    standalone: true,
    imports: [
        CommonModule,
        CountdownComponent,
        DfImageDirective,
        HrefComponent,
        ICmsClientModule,
        LocalVimeoPlayerComponent,
        ShellComponent,
        YoutubePlayerComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsComponentHeroImageComponent>(CMS_COMPONENT_HERO_IMAGE_CONFIG)
export class CmsComponentHeroImageComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: NCmsComponentHeroImage.IData;

    readonly uid = `cms-carousel-${cmsHeroImageUid()}`;

    readonly collectionProducts: NToggle.TId = ['collection', uid];

    protected meta = inject(Meta);
    protected toggleService = inject(ToggleService);

    get imageRatio(): string {
        return this.component?.ratio === 'ratio-full-page'
            ? this.component?.ratioSource || 'ratio-2-1'
            : this.component?.ratio || 'ratio-2-1';
    }

    protected toggleCollection(): void {
        return this.toggleService.toggle(this.collectionProducts);
    }
}
